import { Component } from 'react'
import PropTypes from 'prop-types'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import withStyles from 'beam/dist/styles/index'
import { withTranslation } from 'react-i18next'
import { uniq } from 'lodash'

import EVENT_TYPE from '../const/eventType'
import AudioMultiMenu from './AudioMultiMenu'
import AudioContent from './AudioContent'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-AudioPanel-'

const styles = theme => ({
  panelRoot: {
    boxShadow: 'none',
  },
  panelBody: {
    padding: theme.spacing(1, 0),
  },
})

class AudioPanel extends Component {
  static displayName = 'AudioPanel'

  static propTypes = {
    classes: PropTypes.object.isRequired,
    contactId: PropTypes.number.isRequired,
    callDurationMs: PropTypes.number.isRequired,
    audioDurationMs: PropTypes.number.isRequired,
    audioOffsetMs: PropTypes.number.isRequired,
    storageFileOffsetMs: PropTypes.number.isRequired,
    isRootRecording: PropTypes.bool,
    setTime: PropTypes.func,
    currentTime: PropTypes.number,
    evalId: PropTypes.number,
    events: PropTypes.array,
    energy: PropTypes.object,
    comments: PropTypes.array,
    speechHits: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    energyError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onContactUpdate: PropTypes.func.isRequired,
    onEvalUpdate: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    showSpeechHits: PropTypes.bool,
    zoomed: PropTypes.bool,
  }

  static defaultProps = {
    showSpeechHits: true,
    zoomed: true,
  }

  constructor(props) {
    super(props)

    this.ALL = 'all'
    this.state = {
      selectedEventType: this.ALL,
    }
  }
  getEventTypes() {
    const { events, comments, speechHits, showSpeechHits, t } = this.props

    const availableTypes = uniq([
      ...events.map(e => e.eventType),
      ...comments.map(e => e.eventType),
      ...(showSpeechHits ? speechHits : []).map(e => e.eventType),
    ])

    return [
      {
        value: this.ALL,
        name: t(this.ALL),
      },
      ...availableTypes.map(value => ({
        value,
        name: t(EVENT_TYPE[value.toUpperCase()]),
      })),
    ]
  }

  changeEventType(eventType) {
    this.setState({ selectedEventType: eventType })
  }

  render() {
    const { classes, t, ...contentProps } = this.props

    const { selectedEventType } = this.state

    return (
      <Panel
        titleIcon={<BeamIcon>AccountVoice</BeamIcon>}
        title={t('audio')}
        dense
        variant="light"
        classes={{ root: classes.panelRoot, body: classes.panelBody }}
        dataTestId={`${dataTestIdPrefix}panel`}
        headerTestId={`${dataTestIdPrefix}panel-heading`}
        headerActions={
          <AudioMultiMenu
            eventTypes={this.getEventTypes()}
            selectedEventType={selectedEventType}
            onEventTypeChange={this.changeEventType.bind(this)}
          />
        }
      >
        <ErrorBoundary key={contentProps.contactId}>
          <AudioContent selectedEventType={selectedEventType} {...contentProps} />
        </ErrorBoundary>
      </Panel>
    )
  }
}

export { AudioPanel as UnstyledAudioPanel }

export default withTranslation()(withStyles(styles)(AudioPanel))
